import React from 'react';
import './BackdropBlur.scss';

const BackdropBlur = () => {
    return <div className="a-backdrop-blur" />;
};

export default BackdropBlur;
